import request from '@/utils/request'

// 考试统计
export function examStatistics(data = {}) {
  return request({
    url: '/api/student/exam/examStatistics',
    method: 'get',
    data
  })
}

// 练习统计
export function exerciseStatistics(data = {}) {
  return request({
    url: '/api/student/exam/exerciseStatistics',
    method: 'get',
    data
  })
}

// 考试情况统计
export function examSituation(data = {}) {
  return request({
    url: '/api/student/exam/examConditionStatistics',
    method: 'get',
    params:data
  })
}